module.exports = __webpack_public_path__ + "static/media/7-min.64007bde.png";